import usePrintingDetail from 'components/template/Printing/details/hooks';
import { useModal } from 'context/Modal/Context';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import useCardsApi, { CardsFilters } from 'hooks/queries/cards/useCardsApi';
import { useState } from 'react';
import { pickBy } from 'utils/object';

const DEFAULT_FILTERS = { collection: true };

const usePrintingCardListModal = ({ printingPage }: { printingPage: string }) => {
  const [filters, setFilters] = useState<Partial<CardsFilters>>({});
  const setOrder = (name: string, value: string) => {
    const prevFilters = pickBy(filters, (key) => !key.startsWith('order'));

    setFilters({
      ...prevFilters,
      [name]: value,
    });
  };
  const { data } = usePrintingDetail();
  const isFoil =
    data?.printingPages?.find((page) => page['@id'] === printingPage)?.printOnDemandProduct?.type === 'FOIL';

  const { cards, totalItems, isLoading } = useCardsApi({
    filters: { ...filters, ...DEFAULT_FILTERS, foiled: isFoil ? true : undefined },
    controlled: true,
  });
  const { openModal, closeModal } = useModal();

  const handleCardClick = (id?: string) => {
    if (!id) {
      return;
    }
    openModal(MODAL_NAME.ADD_CARD_TO_PAGE, { cardId: id, printingPage });
  };

  const onFilterSubmit = (values: Partial<CardsFilters>) => {
    const cleanedValues = pickBy(values, (value) => values[value] !== '');
    setFilters(cleanedValues);
    closeModal(MODAL_NAME.FILTERS);
  };

  const onPageChange = (page: number) => {
    setFilters((prevFilters) => {
      return { ...prevFilters, page };
    });
  };

  return {
    cards,
    totalItems,
    handleCardClick,
    onFilterSubmit,
    filters,
    clearFilters: () => setFilters({}),
    onPageChange,
    setOrder,
    isLoading,
  };
};

export default usePrintingCardListModal;
